<template>
  <div>
    <div class="m-2">
      <div class="col-12">
        <button class="btn-remove mb-2" @click="$emit('remove-all')">{{ getTranslatedText('remove all') }}</button>
        <div v-if="currentTab === 'MULTIPLE' && isInvalidMultipleOdds" class="text-infor">
          <i class="bi bi-exclamation-circle"></i>
          {{ getTranslatedText(`The total odds does not meet the minimum value`) }}: &nbsp;{{ minMultipleOdds }}
        </div>

        <div v-if="isSameRace" class="text-infor">
          <i class="bi bi-exclamation-circle"></i>
          {{ getTranslatedText(`there are conflicting races in your betslip, please revise.`) }}
        </div>

        <div v-if="isValidMaxpayout" class="text-infor">
          <i class="bi bi-exclamation-circle"></i>
          {{ getTranslatedText(`you are reached max payout ${maxPayout} ${currencySymbol}`) }}
        </div>
        <div class="text-warn"
          v-html="getTranslatedWithBreakLineText(`by placing a bet, you accept the terms and conditions applied, bet and limits may varies as per max payout limits of ${maxPayout} ${currencySymbol}`)">
        </div>
        <div v-if="isInvalidMultipleOdds" class="text-infor">
          <i class="bi bi-exclamation-circle"></i>
          {{ getTranslatedText(`The total odds does not meet the minimum value`) }}: &nbsp;{{ minMultipleOdds }}
        </div>
      </div>
    </div>

    <div class="booknow"
      :class="{ 'booknow__disable': isBookNowDisabled }"
      @click="$emit('book-now')">
      <div v-if="!isSubmitData">
        {{ !isLogin ? getTranslatedText(`login`) : getTranslatedText(`book now`) }}
      </div>
      <div v-else class="spinner-border text-light" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <div class="row m-2">
      <div class="form-check text-center mb-5">
        <label class="form-check-label">
          <input type="checkbox" class="checkbox-common" checked>
          {{ getTranslatedText('accept all odds and line changes') }}
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import languageMixins from "@/mixins/language/language-mixins";

export default {
  name: 'BetslipActions',
  mixins: [languageMixins],
  props: {
    currentTab: {
      type: String,
      required: true
    },
    isSubmitData: {
      type: Boolean,
      required: true
    },
  },
  computed: {
    isLogin() {
      return this.$store.state.isLogin;
    },
    currencySymbol() {
      return this.$store.state.settings.currencySymbol;
    },
    maxPayout() {
      return this.$store.state.settings.maxPayout;
    },
    minMultipleOdds() {
      return this.$store.state.settings.multiple_bet_minimum_total_odds;
    },
    isSameRace() {
      return this.$store.getters.isSameRace;
    },
    isValidMaxpayout() {
      return this.$store.getters.isValidMaxpayout;
    },
    isInvalidMultipleOdds() {
      return this.$store.getters.isInvalidMultipleOdds;
    },
    isBookNowDisabled() {
      return this.isLogin && (this.isSameRace || this.isValidMaxpayout || (this.currentTab === 'MULTIPLE' && this.isInvalidMultipleOdds));
    },
  }
};
</script> 